import { useState } from "react";
import "../styles/addPartner.css";

const AddPartner = ({ onAdd, isAddingPartner }) => {
  const [name, setName] = useState("");
  const [share, setShare] = useState("");

  const handleAdd = () => {
    onAdd(name, share);
    setName("");
    setShare("");
  };

  return (
    <div className="add-partner">
      <input
        type="text"
        placeholder="Partner Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <input
        type="number"
        placeholder="Your %"
        value={share}
        onChange={(e) => setShare(e.target.value)}
      />
      <button
  onClick={handleAdd}
  disabled={isAddingPartner}
>
  {isAddingPartner ? "Adding..." : "Add"}
</button>
    </div>
  );
};

export default AddPartner;